import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Analytics } from "@/lib/analytics";

const PAGE_HISTORY_KEY = "immovox_page_history";
const VISIT_COUNT_KEY = "immovox_visit_count";
const SESSION_START_KEY = "immovox_session_start";
const ENTRY_PAGE_KEY = "immovox_entry_page";
const SESSION_COUNTED_KEY = "immovox_session_counted";

export const usePageTracking = () => {
  const location = useLocation();

  // Initialise session-level data once
  useEffect(() => {
    // Session start timestamp
    if (!sessionStorage.getItem(SESSION_START_KEY)) {
      sessionStorage.setItem(SESSION_START_KEY, Date.now().toString());
    }

    // Entry page
    if (!sessionStorage.getItem(ENTRY_PAGE_KEY)) {
      sessionStorage.setItem(ENTRY_PAGE_KEY, location.pathname);
    }

    // Increment visit count once per session
    if (!sessionStorage.getItem(SESSION_COUNTED_KEY)) {
      sessionStorage.setItem(SESSION_COUNTED_KEY, "true");
      const current = parseInt(localStorage.getItem(VISIT_COUNT_KEY) || "0", 10);
      localStorage.setItem(VISIT_COUNT_KEY, (current + 1).toString());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // Track page view
    Analytics.pageView(location.pathname);

    // Append to page history (sessionStorage)
    try {
      const stored = sessionStorage.getItem(PAGE_HISTORY_KEY);
      const history: string[] = stored ? JSON.parse(stored) : [];
      // Avoid consecutive duplicates
      if (history[history.length - 1] !== location.pathname) {
        history.push(location.pathname);
        sessionStorage.setItem(PAGE_HISTORY_KEY, JSON.stringify(history));
      }
    } catch { /* ignore */ }
  }, [location.pathname]);
};
